/**
 * Fiyatı formatlar ve para birimi ekler
 * @param {number} price - Formatlanacak fiyat
 * @param {string} currency - Para birimi (varsayılan: TL)
 * @returns {string} Formatlanmış fiyat
 */
export const formatPrice = (price, currency = 'TL') => {
  if (!price && price !== 0) return '';

  // Sayıyı formatla: 1000 -> 1.000
  const formattedPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${formattedPrice} ${currency}`;
};

/**
 * Tarihi formatlar
 * @param {string} date - Formatlanacak tarih
 * @returns {string} Formatlanmış tarih
 */
export const formatDate = (date) => {
  if (!date) return '';
  
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  
  return new Date(date).toLocaleDateString('tr-TR', options);
};

/**
 * Metni belirli bir uzunlukta kısaltır
 * @param {string} text - Kısaltılacak metin
 * @param {number} maxLength - Maksimum uzunluk
 * @returns {string} Kısaltılmış metin
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  
  return text.substring(0, maxLength) + '...';
}; 